import ScalableCanvas from './scalable-canvas'
let logoEl = null
let logoStyle = null
let lastLogoImg = null

function getNewLogoURL (elementId) {
  if (!logoEl) logoEl = document.getElementById(elementId)
  if (!logoStyle) logoStyle = window.getComputedStyle(logoEl)
  if (logoStyle.backgroundImage !== lastLogoImg) {
    lastLogoImg = logoStyle.backgroundImage
    return logoStyle.backgroundImage.slice(4, -1).replace(/"/g, '')
  }
}

export default function ({ logoId, canvasId }) {
  const logo = new ScalableCanvas(getNewLogoURL(logoId), canvasId, { fillParent: false })
  window.addEventListener('resize', function () {
    const newUrl = getNewLogoURL(logoId)
    if (newUrl) logo.setup(newUrl)
  })
  logo.setup(getNewLogoURL(logoId))
}
